export default __webpack_public_path__ + "static/media/sweet-2.04f9c943.jpg";